/*
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2020 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { quickfabStyles } from "@eisinc/App/Widgets/QuickFab/QuickFab";
import { color } from "@eisinc/XDL/Utilities";
import { css } from "styled-components";

quickfabStyles.quickFabWrapper = {
    css: css`
        background-color: ${color('common.background')};
        border: 1px solid ${color('info.main')};
        padding: 15px;
    `,
};

quickfabStyles.content = {
    css: css`
        display: block;
        font-size: 14px;
        margin-bottom: 5px;
    `,
};

quickfabStyles.title = {
    forwardAs: "p",
    lineHeight: "21px",
    size: 18,
    color: "info.main",
    weight: 600,
    css: css`
        margin-bottom: 8px;
    `,
};

quickfabStyles.wrapper = {
    css: css`
        border-bottom: 1px solid ${color('common.ui2')};
        padding-bottom: 16px;
        margin-bottom: 16px;
    `,
};

quickfabStyles.link = {
    typographyProps: {
        size: 14,
        weight: 500,
    },
};